import moment from 'moment';

export default function DateTimeText({ dateTime }) {
  return dateTime !== '' ? moment(dateTime).format('DD/MM/YYYY - HH:mm') : 'NA';
}
